import { useMemo } from 'react';

/* Хук на случай если по какой-то причине неизвестно общее число элементов в пагинации */
export const useDynamicPaginatorCount = (
  limit: number,
  offset: number,
  currentData: any[],
  pending: boolean
): number => {
  return useMemo(() => {
    const isLastPage = currentData.length < limit || pending;

    return isLastPage ? offset + currentData.length : offset + limit + 1;
  }, [limit, offset, currentData.length, pending]);
};
